import { render, staticRenderFns } from "./success-validate-account.vue?vue&type=template&id=01bd2d69&scoped=true"
import script from "./success-validate-account.vue?vue&type=script&lang=js"
export * from "./success-validate-account.vue?vue&type=script&lang=js"
import style0 from "./success-validate-account.vue?vue&type=style&index=0&id=01bd2d69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd2d69",
  null
  
)

export default component.exports